import { render, staticRenderFns } from "./SfSticky.vue?vue&type=template&id=ca1e0af8"
import script from "./SfSticky.vue?vue&type=script&lang=js"
export * from "./SfSticky.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfSticky.vue?vue&type=style&index=0&id=ca1e0af8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "2d9f03f2"
  
)

export default component.exports